/**
 * @description 在webview中打印信息
 * @param msg 打印的信息
 */
const webviewConsole = (msg: string): void => {
  let consoleString = '';
  if (typeof msg === 'object') {
    consoleString = JSON.stringify(msg);
  } else if (typeof msg === 'string') {
    consoleString = msg;
  } else {
    consoleString = String(msg);
  }
  consoleString = '- ' + consoleString;
  let webviewConsoleDom = document.querySelector('#webview-console');
  let webviewConsoleContentDom = document.querySelector('#webview-console-content');
  if (!webviewConsoleDom) {
    const wrapperDom = document.createElement('div');
    wrapperDom.setAttribute('id', 'webview-console');
    wrapperDom.setAttribute(
      'style',
      'position: fixed;left: 0;bottom: 0;width: 100vw;max-height: 50vh;overflow: auto;padding: 20px;font-size: 16px;line-height: 20px;color: #000;background: rgba(255,255,255,0.9);z-index: 9999;border: 1px solid rgba(0,0,0,0.2);box-sizing: border-box;',
    );
    webviewConsoleContentDom = document.createElement('div');
    webviewConsoleContentDom.setAttribute('id', 'webview-console-content');
    webviewConsoleContentDom.setAttribute('style', 'word-break: break-all;');
    const clearBtnDom = document.createElement('span');
    clearBtnDom.setAttribute(
      'style',
      'position: absolute;right: 0;top: 0;padding: 5px;width: 10vw;height: 3vw;font-size: 14px;color: #999;',
    );
    clearBtnDom.textContent = 'clear';
    wrapperDom.appendChild(webviewConsoleContentDom);
    wrapperDom.appendChild(clearBtnDom);
    document.body.appendChild(wrapperDom);
    webviewConsoleDom = wrapperDom;
    clearBtnDom.addEventListener('click', function () {
      webviewConsoleContentDom!.innerHTML = '';
    });
  }
  const currentText = webviewConsoleContentDom!.innerHTML;
  if (!currentText) {
    webviewConsoleContentDom!.innerHTML = consoleString;
  } else {
    webviewConsoleContentDom!.innerHTML = currentText + '<br />' + consoleString;
  }
  const contentHeight = (webviewConsoleContentDom as any).offsetHeight;
  if (contentHeight > window.innerHeight * 0.5) {
    webviewConsoleDom.scrollBy({
      left: 0,
      top: contentHeight + 20,
      behavior: 'smooth',
    });
  }
};

export default webviewConsole;
